import React, { useState, useEffect } from 'react';
import { Table, Typography, InputNumber, Switch } from 'antd';
import { DeleteForeverSharp } from "@mui/icons-material";
import {useEnsureTickersLoaded} from "../../../hooks/useEnsureTickersLoaded";
import TickerChip from "../../../Components/TickerChip";

const BuilderTable = ({ items, onItemsUpdate }) => {
    const [dataSource, setDataSource] = useState(items);
    console.log("items", items);
    const stocksAndEtfs = items.filter(item => item.type === 'stock' || item.type === 'etf').map(item => item.id);
    const {tickers, loading} = useEnsureTickersLoaded(stocksAndEtfs || ['spy']);

    useEffect(() => {
        setDataSource(items); // Sync with external changes
    }, [items]);

    const handleLockChange = (id, checked) => {
        const newData = dataSource.map(item => {
            if (item.id === id) {
                return { ...item, _locked: checked };
            }
            return item;
        });
        setDataSource(newData);
        onItemsUpdate(newData);
    };

    const handleWeightChange = (value, record) => {
        const newData = dataSource.map(item => {
            if (item.id === record.id) {
                return { ...item, wgt: value };
            }
            return item;
        });
        setDataSource(newData);
        onItemsUpdate(newData);
    };

    const handleFlagForRemoval = (id) => {
        const newData = dataSource.map(item => {
            if (item.id === id) {
                return { ...item, _flagForRemoval: true };
            }
            return item;
        });
        setDataSource(newData);
        onItemsUpdate(newData);
    }

    const getRowClassName = (record) => {
        return record._flagForRemoval ? 'flag--danger' : '';
    };

    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (text, record) => {
                const tickerItem = tickers.find(ticker => ticker.symbol === record.id);
                if (tickerItem) {
                    return <TickerChip ticker={tickerItem} />
                }
                return <Typography.Text style={{fontWeight: '600'}}>{text}</Typography.Text>
            },
            fixed: 'left',
            width: 200
        },
        {
            title: 'Lock/Unlock',
            dataIndex: '_locked',
            key: '_locked',
            render: (text, record) => (
                <Switch checked={record._locked} onChange={checked => handleLockChange(record.id, checked)} />
            ),
        },
        {
            title: 'Weight',
            dataIndex: 'wgt',
            key: 'wgt',
            render: (text, record) => (
                <InputNumber min={0} max={100} value={record.wgt} onChange={value => handleWeightChange(value, record)} disabled={record._locked} precision={2} />
            ),
        },
        {
            title: 'Remove',
            dataIndex: 'remove',
            key: 'remove',
            render: (_, record) => (
                <DeleteForeverSharp onClick={() => handleFlagForRemoval(record.id)} />
            )
        },
    ];

    return <Table
        dataSource={dataSource}
        columns={columns}
        rowClassName={getRowClassName}
        rowKey="id"
        pagination={false}
        style={{
            maxHeight: '600px',
            overflowY: 'scroll',
            width: '100%'
        }}


    />;
};

export default BuilderTable;
